// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get } from "@insite/client-framework/Services/ApiService";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridContainer, GridItem } from "@insite/mobius/index";
import Link from "@insite/mobius/Link";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import React, { useContext } from "react";

type Props = WidgetProps;

export interface EmailTesterStyles {
    container?: GridContainerProps;
}

export const emailTesterStyles: EmailTesterStyles = {};

const styles = emailTesterStyles;

interface EmailTesterResponeModel {
    message: string;
}

const EmailTester: React.FC<Props> = ({ fields: { isLocal, emailsDirectory } }) => {
    const toasterContext = useContext(ToasterContext);

    const sendEmail = (email: string) => {
        get<EmailTesterResponeModel>(
            `/api/v1/EmailTester/PublishSendEamil?readFromLocalDirectory=${isLocal}${
                isLocal ? `&directory=${emailsDirectory}` : ""
            }&templateName=${email}&sendEmail=true`,
        ).then(
            () => {
                toasterContext.addToast({
                    body: `${email} ${translate("Published and Sent")}`,
                    messageType: "success",
                });
            },
            () => {
                toasterContext.addToast({
                    body: `${email} ${translate("Published and Send faild")}`,
                    messageType: "danger",
                });
            },
        );
    };

    return (
        <GridContainer {...styles.container}>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("AbandonedCart")}>Abandoned Cart</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("Admin_AccountActivation")}>Admin Account Activation</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("Admin_ResetPassword")}>Admin Reset Password</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("ContactUsTemplate")}>Contact Us Template</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("ForgotPassword")}>Forgot Password</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("InviteToList")}>Invite To List</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("ListEmailReminder")}>List Email Reminder</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("OrderConfirmation")}>Order Confirmation</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("PunchOut_FailedOrderRequest")}>PunchOut Failed Order Request</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("RequestRMA")}>Request RMA</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("RfqQuote")}>Rfq Quote</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("SendAListCopy")}>Send A List Copy</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("ShareInvoice")}>Share Invoice</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("ShareListWithBillTo")}>Share List With BillTo</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("ShareOrder")}>Share Order</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("ShipmentConfirmation")}>Shipment Confirmation</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("StatusReport")}>Status Report</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("TellAFriend")}>Tell A Friend</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("OrderSubmitFailures")}>Order Submit Failures</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("Website_AccountActivation")}>Website Account Activation</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("Website_ResetPassword")}>Website Reset Password</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("Website_UserNameChanged")}>Website User Name Changed</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("RCAccountSendUsername")}>RCAccountSendUsername</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("RCBlockedOrder")}>RCBlockedOrder</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("RCNotifyMe")}>RCNotifyMe</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("RCResetPasswordToken")}>RCResetPasswordToken</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("RCE_TCReport")}>RCE_TCReport</Link>
            </GridItem>
            <GridItem width={12}>
                <Link onClick={() => sendEmail("SubscriptionEmail")}>SubscriptionEmail</Link>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: EmailTester,
    definition: {
        displayName: "Email Tester",
        group: "XNGAGE" as any,
        fieldDefinitions: [
            {
                name: "isLocal",
                displayName: "Is Local Enviroment",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: "emailsDirectory",
                displayName: "Emails Directory",
                editorTemplate: "TextField",
                fieldType: "General",
                defaultValue: "",
                isRequired: true,
                isVisible: item => item.fields.isLocal,
            },
        ],
    },
};

export default widgetModule;
